import { Link } from 'react-router-dom';
import { ctaData } from '@/mocks/home';

export default function CTASection() {
  return (
    <section className="py-0">
      <div className="flex flex-col lg:flex-row">
        {/* Left - Image */}
        <div className="w-full lg:w-1/2 relative h-[350px] md:h-[500px] overflow-hidden bg-background-100">
          <img
            src={ctaData.leftImageUrl}
            alt="51吃瓜黑料APP下载"
            title="51吃瓜黑料 随时随地掌握全网黑料"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
          <div className="absolute bottom-0 left-0 right-0 p-8">
            <p className="text-foreground-400 font-label text-xs mb-3">{ctaData.leftTag}</p>
            <p className="font-heading text-2xl md:text-4xl font-bold text-background-50 leading-tight">
              {ctaData.leftTitle}
              <br />
              {ctaData.leftTitle2}
              <br />
              {ctaData.leftTitle3}
            </p>
          </div>
        </div>

        {/* Right - Content */}
        <div className="w-full lg:w-1/2 bg-background-50 flex items-center justify-center py-14 md:py-20 px-8 md:px-16">
          <div className="max-w-md text-center">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-6 leading-tight">
              {ctaData.rightTitle}
            </h2>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-8">
              {ctaData.rightDescription}
            </p>
            <Link
              to="/category/exposure-gate"
              className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-medium text-sm whitespace-nowrap hover:bg-primary-600 transition-colors duration-200"
            >
              {ctaData.rightButtonText}
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}